// extracted by mini-css-extract-plugin
export default {"dividerRoot":"divider_dividerRoot__gPUoQ"};